// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7ffbcd6e","239":"ca1146bd","667":"62d4ae5f"}[chunkId] + ".chunk.js";
};